import {
  Doc,
  breakpointDown,
  Button,
  Select,
  SELECT_LABEL_CLASS_NAME,
} from '@sparemin/blockhead';
import styled from 'styled-components';
import { ShareExportingBody } from 'components/ExportModalContents';
import BaseModal from 'components/Modal';
import { MaxCharactersSelectorStyleProps } from './types';

export const Modal = styled(BaseModal)`
  width: 570px;
  text-align: start;

  ${breakpointDown('md')`
    width: 100%;
  `}
`;

export const Icon = styled(Doc)`
  width: 60px;
  padding-top: 8px;
`;

export const Loader = styled(ShareExportingBody)`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const Body = styled(Modal.Body)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ExportTranscriptButton = styled(Button)`
  margin-top: 16px;
`;

export const MaxCharactersSelector = styled(
  Select,
)<MaxCharactersSelectorStyleProps>`
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.25 : 1)};

  .${SELECT_LABEL_CLASS_NAME} {
    font-size: 14px;
    font-weight: 700;
    line-height: 1.33;
  }
`;

export const CustomOptionSelectValue = styled.label`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
